import { WebFsError } from '#common/types';
export class ObjectStoreError extends WebFsError {
}
export class BucketNotFoundError extends ObjectStoreError {
    constructor(bucketName) {
        super(`Bucket ${bucketName} not found`);
    }
}
export class BucketNotEmptyError extends ObjectStoreError {
    constructor(bucketName) {
        super(`Bucket ${bucketName} not empty`);
    }
}
export class ObjectNotFoundError extends ObjectStoreError {
    constructor(objectKey) {
        super(`Object ${objectKey} not found`);
    }
}
export class AuthorizationError extends ObjectStoreError {
    errorCode;
    constructor(message, errorCode) {
        super(message ?? 'Authorization exception');
        this.errorCode = errorCode;
    }
}
export class AccessDeniedError extends AuthorizationError {
}
export class HttpStoreError extends ObjectStoreError {
}
export class HttpInvalidCheckSumError extends HttpStoreError {
}
export class PresignedUrlError extends WebFsError {
}
export class PresignedUrlUnreachableError extends PresignedUrlError {
}
